@let onglet = data().ongletTraitement;

@if (onglet.zr_surveillanceTemperature?.length) {
<p class="section-sub-title"><mat-icon>thermostat</mat-icon>Surveillance de la température</p>
<div class="timeline">
  @for (surv of onglet.zr_surveillanceTemperature; track $index) {
  @if (surv.input_temperature) {
  <div class="timeline-item">
    <div class="timeline-dot"></div>
    <div class="timeline-content">
      <span class="time-badge secondary"><mat-icon>thermostat</mat-icon>{{ surv.input_heure | carnetHeure }}</span>
      <span class="temp-value">{{ surv.input_temperature }}°C</span>
      @if (surv.select_priseTempPar) {
      <span class="muted">par {{ surv.select_priseTempPar }}</span>
      }
      @if (surv.radio_directionInformee === 1) {
      <span class="muted">— Direction informée</span>
      }
      @if (surv.radio_parentAverti === 1) {
      <span class="muted">— Parents informés
        @if (commentParentAvertiLabels[surv.radio_commentParentAverti]; as mode) {
        ({{ mode }})
        }
      </span>
      }
      @if (getSurveillanceSymptomes(surv).length > 0) {
      <span class="chips-row">
        @for (symptome of getSurveillanceSymptomes(surv); track symptome) {
        <mat-chip class="chip-small">{{ symptome }}</mat-chip>
        }
      </span>
      }
    </div>
  </div>
  }
  }
</div>
}

@if (onglet.zr_antipyretique?.length) {
<p class="section-sub-title"><mat-icon>medication</mat-icon>Antipyrétiques administrés</p>
<div class="timeline">
  @for (anti of onglet.zr_antipyretique; track $index) {
  @if (anti.input_heure) {
  <div class="timeline-item">
    <div class="timeline-dot"></div>
    <div class="timeline-content">
      <span class="time-badge secondary"><mat-icon>medication</mat-icon>{{ anti.input_heure | carnetHeure }}</span>
      @if (anti.radio_medicamentAdministre === 1) {
      <span>{{ medicamentAdministreLabels[1] }}</span>
      } @else if (anti.input_autreMedicament) {
      <span>{{ anti.input_autreMedicament }}</span>
      }
      @if (posologieLabels[anti.radio_posologie]; as posologie) {
      <span class="muted">— {{ posologie }}</span>
      }
      @if (anti.input_poidsEnfant) {
      <span class="muted">— {{ anti.input_poidsEnfant }} kg</span>
      }
      @if (anti.input_administrePar) {
      <span class="muted">par {{ anti.input_administrePar }}</span>
      }
      @if (anti.radio_directionInformee === 1) {
      <span class="muted">— Direction informée</span>
      }
      @if (anti.radio_parentAverti === 1 && anti.input_quiAvertiParent) {
      <span class="muted">— Parents avertis par {{ anti.input_quiAvertiParent }}
        @if (commentParentAvertiLabels[anti.radio_commentParentAverti]; as mode) {
        ({{ mode }})
        }
      </span>
      }
    </div>
  </div>
  }
  }
</div>
}

@if (onglet.zr_traitementPAI?.length) {
<p class="section-sub-title"><mat-icon>medical_information</mat-icon>Traitement sur ordonnance / PAI</p>
<div class="timeline">
  @for (pai of onglet.zr_traitementPAI; track $index) {
  @if (pai.input_heure) {
  <div class="timeline-item">
    <div class="timeline-dot"></div>
    <div class="timeline-content">
      <span class="time-badge secondary"><mat-icon>medical_information</mat-icon>{{ pai.input_heure | carnetHeure }}</span>
      @if (pai.input_medicamentAdministre) {
      <span>{{ pai.input_medicamentAdministre }}</span>
      }
      @if (pai.select_administrePar) {
      <span class="muted">par {{ pai.select_administrePar }}</span>
      }
      @if (pai.input_validePar) {
      <span class="muted">— Ord. {{ pai.input_validePar }}</span>
      }
    </div>
  </div>
  }
  }
</div>
}
